import script from "./BalPopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BalPopover.vue?vue&type=script&setup=true&lang=ts"

import "./BalPopover.vue?vue&type=style&index=0&id=4a0f945c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0f945c"]])

export default __exports__